<script>
import LoginDropdown from './LoginDropdown';
import UserMenu from './UserMenu';
import Panel from '../../common/Panel';
import AccountPopover from '@phoenix/mixins/components/myAccount/nav/AccountPopover';

export default {
  components: { Panel, LoginDropdown, UserMenu },

  mixins: [AccountPopover],
};
</script>

<template>
  <panel id="account-panel" reverse :title="$t('MyAccount.account')" :options="panelOptions" :boxed-content="!isLogged">
    <template #content>
      <div v-if="!isLoaded" class="loader-overlay loader-overlay--light">
        <div class="loader loader--dark">
          <div class="loader__inner"></div>
        </div>
      </div>
      <login-dropdown v-else-if="!isLogged" :links="menuLinks.guestLinks" />
      <user-menu v-else :links="menuLinks.loggedLinks" />
    </template>
  </panel>
</template>
